import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiGetRPYM, apiSaveRPYM } from "../api/rutaPYMApi";
import { apiGetGrupos } from "../api/gruposApi";
import { apiGetSubGrupos } from "../api/subGruposApi";
import empresaApi from "../api/empresaApi";
import useAuth from "./useAuth";

export const useRoutePYM = () => {
  const { user } = useAuth();
  const [routespym, setRoutespym] = useState([]);
  const [empresasActivas, setEmpresasActivas] = useState([]);
  const [routeSelected, setRouteSelected] = useState("");
  const [groupSelected, setGroupSelected] = useState("");
  const [groups, setGroupsByRuta] = useState([]);
  const [subgroups, setSubgroupByRuta] = useState([]);

  const [consFilterSelected, setConsFilterSelected] = useState("");
  const [routeFilterSelected, setRouteFilterSelected] = useState("");
  const [groupFilterSelected, setGroupFilterSelected] = useState("");
  const [subgroupFilterSelected, setSubgroupFilterSelected] = useState("");
  const [groupsFilter, setGroupsFilterByRuta] = useState([]);
  const [subgroupsFilter, setSubgroupFilterByRuta] = useState([]);

  const [form, setForm] = useState({
    id: "",
    Consecutivo: "",
    id_empresa: 0,
    idSubGrupo: "",
    Sexo: "",
    Inicial: "",
    Final: "",
    Vigencia: "",
    Observaciones: "",
    orden: "",
    estado: 1,
  });

  const loadEmpresasActivas = async () => {
    try {
      const rs = await empresaApi.getAllActivas();
      setEmpresasActivas(rs.data || []);
    } catch (error) {
      toast.error("Error cargando empresas");
    }
  };

  useEffect(() => {
    loadEmpresasActivas();
  }, []);

  const loadRoutespym = async (idSubgrupo = "", idCons = "") => {
    setRoutespym([]);
    setConsFilterSelected(idCons);
    setSubgroupFilterSelected(idSubgrupo);

    if (!idSubgrupo && !idCons) return;
    try {
      const res = await apiGetRPYM(idSubgrupo, idCons);
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);
      setRoutespym(list);
    } catch {
      toast.error("fn loadRoutespym: Error cargando routespym");
      console.log("fn loadRoutespym: Error cargando routespym");
    }
  };

  const setRoutespymEdit = async (rutapym) => {
    try {
      if (!rutapym) {
        handleNew();
        return;
      }

      await getGroupByRoute(rutapym.idRuta);
      await getSubGruposByGrupo(rutapym.idGrupo);

      setForm({
        id: rutapym.id || "",
        Consecutivo: rutapym.Consecutivo || "",
        id_empresa: rutapym.id_empresa || 0,
        idSubGrupo: rutapym.idSubGrupo || "",
        Sexo: rutapym.Sexo || "",
        Inicial: rutapym.Inicial || "",
        Final: rutapym.Final || "",
        Vigencia: rutapym.Vigencia || "",
        Observaciones: rutapym.Observaciones || "",
        orden: rutapym.orden || "",
        estado: rutapym.estado || 0,
      });
    } catch {
      toast.error("fn setRoutespymEdit: Error consultando rutas pym");
      console.log("fn setRoutespymEdit: Error consultando rutas pym");
    }
  };

  const handleNew = () => {
    setForm({
      id: "",
      Consecutivo: "",
      id_empresa: 0,
      idSubGrupo: "",
      Sexo: "",
      Inicial: "",
      Final: "",
      Vigencia: "",
      Observaciones: "",
      orden: "",
      estado: 1,
    });

    setGroupSelected("");
    setRouteSelected("");
  };

  const saveRoutespym = async () => {
    if (!form.Consecutivo) return toast.error("Seleccione el programa (Consecutivo)");

    if (!form.Inicial) return toast.error("Digite la edad inicial");
      
    if (!form.Final) return toast.error("Digite la edad final");

    if (!form.Sexo) return toast.error("Seleccione el sexo");

    if (!form.estado) return toast.error("Seleccione el estado");

    try {
      const payload = {
        ...form,
        id_empresa: form.id_empresa || 0,
        userId: user.id,
      };
      const res = await apiSaveRPYM(payload);

      if (!res.success) return toast.error(res.message || "Error guardando ruta_pym");
      
      toast.success(res.message);
      handleNew();
      setGroupsByRuta([]);
      setSubgroupByRuta([]);
      loadRoutespym(subgroupFilterSelected,consFilterSelected);

      return true;
    } catch {
      toast.error("fn saveRoutespym: Error guardando ruta_pym");
      console.error("fn saveRoutespym: Error guardando ruta_pym");
    }
  };

  const getGroupByRoute = async (idRuta, filter = 0) => {
    if (filter) {
      setRouteFilterSelected(idRuta);
    } else {
      setRouteSelected(idRuta);
    }

    try {
      if (!idRuta) {
        setGroupsByRuta([]);
        setGroupsFilterByRuta([]);
        return;
      }

      const res = await apiGetGrupos(idRuta);
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);

      if (filter) {
        setGroupsFilterByRuta(list);
      } else {
        setGroupsByRuta(list);
      }
    } catch (error) {
      toast.error("fn getGroupByRoute: Error cargando grupos");
      console.log("fn getGroupByRoute: Error cargando grupos");
    }
  };

  const getSubGruposByGrupo = async (idGrupo, filter = 0) => {
    if (filter) {
      setGroupFilterSelected(idGrupo);
    } else {
      setGroupSelected(idGrupo);
    }

    try {
      if (!idGrupo) {
        setSubgroupByRuta([]);
        setSubgroupFilterByRuta([]);
        return;
      }

      const res = await apiGetSubGrupos("", idGrupo);
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);

      if (filter) {
        setSubgroupFilterByRuta(list);
      } else {
        setSubgroupByRuta(list);
      }
    } catch (error) {
      toast.error("fn getSubGruposByGrupo: Error cargando subgrupos");
      console.log("fn getSubGruposByGrupo: Error cargando subgrupos");
    }
  };

  return {
    routespym,
    empresasActivas,
    form,
    setForm,
    saveRoutespym,
    loadRoutespym,
    getGroupByRoute,
    routeSelected,
    groups,
    getSubGruposByGrupo,
    groupSelected,
    subgroups,
    groupsFilter,
    subgroupFilterSelected,
    routeFilterSelected,
    groupFilterSelected,
    subgroupsFilter,
    consFilterSelected,
    setRoutespymEdit,
  };
};
